import { render, staticRenderFns } from "./indemnityDetail.vue?vue&type=template&id=2e592d92&scoped=true&"
import script from "./indemnityDetail.vue?vue&type=script&lang=js&"
export * from "./indemnityDetail.vue?vue&type=script&lang=js&"
import style0 from "./indemnityDetail.vue?vue&type=style&index=0&id=2e592d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e592d92",
  null
  
)

export default component.exports